import imageSizes from '../imageSizes';
const getImageSizeBasedOnViewport = _ref => {
  let {
    device,
    lazyLoad
  } = _ref;
  const isXs = device?.is?.xs || false;
  const mediaType = device?.mediaType || '';

  // If NOT xs, return image sizes from config
  if (!isXs && lazyLoad) {
    const mediaSize = `${'inventoryListing' + mediaType.charAt(0).toUpperCase() + mediaType.slice(1)}`;
    return imageSizes[mediaSize];
  }

  // If xs, return default inventory listing sizes
  return imageSizes.inventoryListing;
};
export default getImageSizeBasedOnViewport;